import Experience from "../Experience.js";
import * as THREE from "three/webgpu";
import {mix, oneMinus, smoothstep, step, uniform, uv} from "three/tsl";

export default class Cable {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;

        this.properties = {
            thickness: 0.05,
            color: new THREE.Color(0x000000),
            electricityColor: new THREE.Color(0xff941a),
            glowColor: new THREE.Color(0xffffcc),
            glowWidth: 0.05
        }
        
        this.setGeometry();
        this.setMaterial();
        this.setMesh();
    }
    
    setGeometry() {
        const points = [
            new THREE.Vector3(0, 0, -1),
            new THREE.Vector3(0, 0, -1.001),
            new THREE.Vector3(-.75, 0, -2),
            new THREE.Vector3(0, 0, -3),
            new THREE.Vector3(1.5, 0, -4),
            new THREE.Vector3(-1, 0, -5),
            new THREE.Vector3(0, 0, -6),
            new THREE.Vector3(1.25, 0, -7.25),
        ];

        const spline = new THREE.CatmullRomCurve3(points.reverse());
        
        this.geometry = new THREE.TubeGeometry(
            spline,
            128,
            this.properties.thickness,
            32);
    }
    
    setMaterial() {
        // Shader Uniforms
        this.uFillProgress = uniform(0);
        const uCableColor = uniform(this.properties.color);
        const uElectricityColor = uniform(this.properties.electricityColor);
        const uGlowColor = uniform(this.properties.glowColor);
        const uGlowWidth = uniform(this.properties.glowWidth);

        // Node Material
        this.material = new THREE.MeshBasicNodeMaterial();

        // Base progress fill
        const progress = this.uFillProgress;
        const baseFillMask = oneMinus(step(progress, uv().x));

        // Glow mask = a small section in front of the fill progress that glows
        const glowMask = baseFillMask.sub(oneMinus(smoothstep(progress.sub(uGlowWidth), progress, uv().x)));

        const baseColor = mix(uCableColor, uElectricityColor, baseFillMask);
        const glowColor = mix(baseColor, uGlowColor.mul(3), glowMask);

        this.material.colorNode = glowColor;
    }
    
    setMesh() {
        this.mesh = new THREE.Mesh(this.geometry, this.material);
        
        this.scene.add(this.mesh);
    }
}